import { buildFloorPlanPaintSequence } from '../nodes/floor-plan-element-nodes';
import { floorPlanStageRectsIntersect } from '../geometry/floor-plan-multi-selection-geometry';
import type { UppFloorPlanModel } from '../plan/floor-plan-model';

export interface FloorPlanStageMarqueePickContentGroup {
  findOne(cb: (n: any) => boolean): any;
}

/**
 * Collects element ids whose Konva nodes intersect the marquee box in Stage space.
 */
export function collectFloorPlanElementIdsIntersectingStageBox(
  model: UppFloorPlanModel,
  contentGroup: FloorPlanStageMarqueePickContentGroup,
  stage: unknown,
  box: { x: number; y: number; width: number; height: number },
): string[] {
  const ids: string[] = [];
  const paintSequence = buildFloorPlanPaintSequence(model.elements);
  for (const el of paintSequence) {
    const node = contentGroup.findOne(
      (n: any) => n !== undefined && typeof n.id === 'function' && n.id() === el.uuid,
    );
    if (!node) {
      continue;
    }
    let r: { x: number; y: number; width: number; height: number };
    try {
      r = node.getClientRect({ relativeTo: stage, skipStroke: true });
    } catch {
      continue;
    }
    if (floorPlanStageRectsIntersect(box, r)) {
      ids.push(el.uuid);
    }
  }
  return ids;
}
